// Complete Texas Dealership Forms Generator
import { generateForm130U } from './texasForm130U';

// Bill of Sale
export const generateBillOfSale = (dealData) => {
  const today = new Date().toLocaleDateString();
  const vehicle = dealData?.vehicle || dealData?.vehicles_db2025 || {};
  const customer = dealData?.customer || {};
  const pricing = dealData?.pricing || {};
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Bill of Sale</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 14px; line-height: 1.8; margin: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .header h1 { font-size: 28px; margin: 10px 0; }
        .field { margin-bottom: 15px; }
        .label { font-weight: bold; }
        .value { border-bottom: 1px solid #999; display: inline-block; min-width: 200px; padding: 2px 5px; }
        .signature-line { border-bottom: 1px solid #000; margin: 30px 0 5px 0; }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>MOTOR VEHICLE BILL OF SALE</h1>
        <p>Paradise-Performance<br/>1301 N Watson Rd Suite 128, Arlington, TX 76006<br/>Phone: (817) 382-2316</p>
      </div>
      
      <p>Date: <strong>${today}</strong></p>
      <p><strong>Seller:</strong> Paradise-Performance</p>
      <p><strong>Buyer:</strong> ${customer.firstName || customer.customer_name || ''} ${customer.lastName || ''}</p>
      
      <h2>VEHICLE INFORMATION</h2>
      <div class="field">
        <span class="label">Year:</span> <span class="value">${vehicle.year || ''}</span>
      </div>
      <div class="field">
        <span class="label">Make:</span> <span class="value">${vehicle.make || ''}</span>
      </div>
      <div class="field">
        <span class="label">Model:</span> <span class="value">${vehicle.model || ''}</span>
      </div>
      <div class="field">
        <span class="label">VIN:</span> <span class="value">${vehicle.vin || ''}</span>
      </div>
      <div class="field">
        <span class="label">Mileage:</span> <span class="value">${vehicle.mileage || ''}</span>
      </div>
      
      <h2>PURCHASE PRICE</h2>
      <div class="field">
        <span class="label">Vehicle Price:</span> $<span class="value">${pricing.vehiclePrice || dealData.vehicle_price || '0'}</span>
      </div>
      <div class="field">
        <span class="label">Total Amount:</span> $<span class="value">${pricing.totalAmount || dealData.total_price || '0'}</span>
      </div>
      
      <div style="margin-top: 50px;">
        <div class="signature-line"></div>
        <p>Buyer Signature</p>
        
        <div class="signature-line"></div>
        <p>Seller/Dealer Representative</p>
      </div>
    </body>
    </html>
  `;
};

// Buyers Guide
export const generateBuyersGuide = (dealData) => {
  const vehicle = dealData?.vehicle || dealData?.vehicles_db2025 || {};
  const warranty = dealData?.warranty || { type: 'AS_IS' };
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Buyers Guide</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 11px; line-height: 1.4; margin: 20px; }
        .container { border: 3px solid #000; padding: 15px; }
        .header { background: #000; color: #fff; padding: 10px; text-align: center; margin: -15px -15px 15px -15px; }
        .checkbox { display: inline-block; width: 20px; height: 20px; border: 2px solid #000; margin-right: 10px; }
        .checked { background: #000; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>BUYERS GUIDE</h1>
          <p>IMPORTANT: Spoken promises are difficult to enforce. Ask dealer to put all promises in writing.</p>
        </div>
        
        <h2>VEHICLE</h2>
        <p>${vehicle.year || ''} ${vehicle.make || ''} ${vehicle.model || ''}</p>
        <p>VIN: ${vehicle.vin || ''}</p>
        
        <h2>WARRANTIES FOR THIS VEHICLE:</h2>
        <p><span class="checkbox ${warranty.type === 'AS_IS' ? 'checked' : ''}"></span> <strong>AS IS - NO DEALER WARRANTY</strong></p>
        <p>YOU WILL PAY ALL COSTS FOR ANY REPAIRS.</p>
        
        <p><span class="checkbox ${warranty.type === 'WARRANTY' ? 'checked' : ''}"></span> <strong>DEALER WARRANTY</strong></p>
        
        <p><span class="checkbox ${warranty.type === 'IMPLIED' ? 'checked' : ''}"></span> <strong>IMPLIED WARRANTIES ONLY</strong></p>
        
        <div style="margin-top: 50px;">
          <p>____________________<br/>Buyer's Signature & Date</p>
          <p>____________________<br/>Dealer Representative & Date</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

// Odometer Disclosure
export const generateOdometerDisclosure = (dealData) => {
  const today = new Date().toLocaleDateString();
  const vehicle = dealData?.vehicle || dealData?.vehicles_db2025 || {};
  const customer = dealData?.customer || {};
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Odometer Disclosure</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; line-height: 1.6; margin: 20px; }
        .header { text-align: center; margin-bottom: 30px; }
        .field { margin-bottom: 10px; }
        .label { font-weight: bold; }
        .value { border-bottom: 1px solid #000; display: inline-block; min-width: 200px; padding: 2px; }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>FEDERAL ODOMETER DISCLOSURE STATEMENT</h1>
      </div>
      
      <h2>VEHICLE</h2>
      <p>${vehicle.year || ''} ${vehicle.make || ''} ${vehicle.model || ''}</p>
      <p>VIN: ${vehicle.vin || ''}</p>
      
      <h2>ODOMETER READING</h2>
      <p>The odometer now reads: <strong>${vehicle.mileage || '_______'}</strong> miles</p>
      
      <p>☑ I certify that to the best of my knowledge the odometer reading reflects the actual mileage of the vehicle.</p>
      
      <h2>TRANSFEROR (SELLER)</h2>
      <p>Paradise-Performance<br/>1301 N Watson Rd Suite 128, Arlington, TX 76006</p>
      <p>Signature: ______________________ Date: ${today}</p>
      
      <h2>TRANSFEREE (BUYER)</h2>
      <p>${customer.firstName || customer.customer_name || ''} ${customer.lastName || ''}</p>
      <p>Signature: ______________________ Date: ${today}</p>
    </body>
    </html>
  `;
};

// Insurance Verification
export const generateInsuranceVerification = (dealData) => {
  const vehicle = dealData?.vehicle || dealData?.vehicles_db2025 || {};
  const customer = dealData?.customer || {};
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Insurance Verification</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; line-height: 1.6; margin: 20px; }
        .header { text-align: center; margin-bottom: 30px; background: #f0f0f0; padding: 15px; }
        .field { margin-bottom: 12px; }
        .label { font-weight: bold; display: inline-block; width: 180px; }
        .value { border-bottom: 1px solid #000; display: inline-block; min-width: 250px; padding: 2px; }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>INSURANCE VERIFICATION FORM</h1>
        <p>State of Texas - Motor Vehicle Insurance Requirement</p>
      </div>
      
      <h2>VEHICLE</h2>
      <p>${vehicle.year || ''} ${vehicle.make || ''} ${vehicle.model || ''}</p>
      <p>VIN: ${vehicle.vin || ''}</p>
      
      <h2>BUYER</h2>
      <p>${customer.firstName || customer.customer_name || ''} ${customer.lastName || ''}</p>
      <p>Driver License #: ${customer.driversLicense || ''}</p>
      
      <h2>INSURANCE INFORMATION</h2>
      <div class="field">
        <span class="label">Insurance Company:</span> <span class="value"></span>
      </div>
      <div class="field">
        <span class="label">Policy Number:</span> <span class="value"></span>
      </div>
      <div class="field">
        <span class="label">Agent Name:</span> <span class="value"></span>
      </div>
      <div class="field">
        <span class="label">Agent Phone:</span> <span class="value"></span>
      </div>
      
      <p style="margin-top: 50px;">____________________<br/>Customer Signature & Date</p>
    </body>
    </html>
  `;
};

// Driver License Copy
export const generateDriverLicenseForm = (dealData) => {
  const customer = dealData?.customer || {};
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Driver License Copy</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; }
        .box { border: 2px dashed #999; padding: 100px 20px; text-align: center; margin: 20px 0; }
      </style>
    </head>
    <body>
      <h1>DRIVER LICENSE COPY</h1>
      <p><strong>Customer:</strong> ${customer.firstName || customer.customer_name || ''} ${customer.lastName || ''}</p>
      <p><strong>License #:</strong> ${customer.driversLicense || 'Not provided'}</p>
      
      <div class="box">
        <p>ATTACH COPY OF DRIVER LICENSE - FRONT</p>
      </div>
      
      <div class="box">
        <p>ATTACH COPY OF DRIVER LICENSE - BACK</p>
      </div>
      
      <p>I certify that the attached is a true copy of my valid driver license.</p>
      <p style="margin-top: 50px;">____________________<br/>Customer Signature & Date</p>
    </body>
    </html>
  `;
};

// Export all forms
export { generateForm130U };

// Helper function to download HTML as file
export const downloadForm = (html, filename) => {
  const blob = new Blob([html], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.html`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Helper to print form
export const printForm = (html) => {
  const printWindow = window.open('', '_blank');
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.print();
};
